import { ref } from "vue";

/**
 * Une action qui n'accepte qu'un envoi à la fois : les clics qui arrivent pendant l'envoi sont ignorés.
 * `enCours` sert à désactiver le bouton qui la déclenche.
 */
export const unSeulEnvoi = <A extends unknown[], R>(
  action: (...args: A) => Promise<R>
) => {
  const enCours = ref(false);

  const lancer = async (...args: A): Promise<R | undefined> => {
    if (enCours.value) {
      return undefined;
    }
    enCours.value = true;
    try {
      return await action(...args);
    } finally {
      enCours.value = false;
    }
  };

  return { enCours, lancer };
};
